import React, { FC } from 'react';

const ArrowTopLarge: FC = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="20" cy="20" r="19.5" stroke="#8E9193"/>
    <path
      d="M20 17.842L14.2598 23.7765C13.9716 24.0745 13.5043 24.0745 13.2161 23.7765C12.9279 23.4786 12.928 22.9955 13.2162 22.6975L19.4782 16.2235C19.7664 15.9255 20.2336 15.9255 20.5218 16.2235L26.7838 22.6975C27.072 22.9955 27.0721 23.4786 26.7839 23.7765C26.4957 24.0745 26.0284 24.0745 25.7402 23.7765L20 17.842Z"
      fill="#151514"
    />
  </svg>
);

export default ArrowTopLarge;
import React, { FC } from 'react';

const ArrowTopLarge: FC = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="20" cy="20" r="19.5" stroke="#8E9193"/>
    <path
      d="M20 17.842L14.2598 23.7765C13.9716 24.0745 13.5043 24.0745 13.2161 23.7765C12.9279 23.4786 12.928 22.9955 13.2162 22.6975L19.4782 16.2235C19.7664 15.9255 20.2336 15.9255 20.5218 16.2235L26.7838 22.6975C27.072 22.9955 27.0721 23.4786 26.7839 23.7765C26.4957 24.0745 26.0284 24.0745 25.7402 23.7765L20 17.842Z"
      fill="#151514"
    />
  </svg>
);

export default ArrowTopLarge;
